import { useSelector } from "react-redux";
import { useNotification } from "./useNotification";
import { addQuestion, deleteQuestionManually, fetchQuestionsThunk, selectAppContent, selectDocumentVisibilityStatus, selectEventId, selectMeCurrentStreamInfo, selectSelectedEpisodeId, selectUser, sendFromItemsToSubmitted } from "@adm-media/adam-store-plugin";
import { useAppDispatch } from "../store";
import { useEffect, useState } from "react";
import init from "../pusher/base";
import { PusherMock } from "pusher-js-mock";
import { subscribeToQAQuestionChannel } from "../pusher/subscribe-to-qa-questions-channel";
import { setWebsiteTitle } from "../utils/setWebsiteTitle";
export var useModeratorPusherConnection = function () {
    var notification = useNotification().notification;
    var dispatch = useAppDispatch();
    var eventId = useSelector(selectEventId);
    var selectedEpisodeId = useSelector(selectSelectedEpisodeId);
    var _a = useSelector(selectUser), token = _a.token, isModerator = _a.isModerator, isChairman = _a.isChairman;
    var _b = useState(0), connectedCounter = _b[0], setConnectedCounter = _b[1];
    var streamId = useSelector(selectMeCurrentStreamInfo).streamId;
    var _c = useState(0), counterQuestions = _c[0], setCounterQuestions = _c[1];
    var contents = useSelector(selectAppContent);
    var documentVisibilityStatus = useSelector(selectDocumentVisibilityStatus);
    var handleDisconnection = function (status) {
        // Don't send notification if user is loggin out
        if (status === "disconnected")
            return;
        notification.error({ message: "You are disconnected", duration: 600 });
    };
    var handleConnection = function () {
        setConnectedCounter(function (prev) { return prev + 1; });
    };
    var _d = useState(null), questionChannelEpId = _d[0], setQuestionChannelEpId = _d[1];
    var _e = useState(null), qaQuestionChannel = _e[0], setQaQuestionChannel = _e[1];
    var _f = useState(null), moderatorPusherSingleton = _f[0], setModeratorPusherSingleton = _f[1];
    // This is the effect when pusher is connected back after a disconnection
    useEffect(function () {
        if (connectedCounter > 1) {
            notification.destroy();
            // Refetch questions on reconnection
            if (selectedEpisodeId) {
                if (typeof streamId === null || !streamId)
                    dispatch(fetchQuestionsThunk({ episode_id: selectedEpisodeId }));
                else
                    dispatch(fetchQuestionsThunk({ episode_id: selectedEpisodeId, stream_id: streamId }));
            }
            notification.success({ message: "You are back online", duration: 10 });
            setConnectedCounter(1); // reset connected counter
        }
    }, [connectedCounter, selectedEpisodeId, streamId, notification]);
    // Update browser tab title
    useEffect(function () {
        if (counterQuestions > 0) {
            setWebsiteTitle("(".concat(counterQuestions, ") New Questions Received"));
        }
        else {
            setWebsiteTitle(contents === null || contents === void 0 ? void 0 : contents.site_title);
        }
        // Do not reset tab title updates if tab is not focused
        if (documentVisibilityStatus === "hidden")
            return;
        setTimeout(function () {
            setCounterQuestions(0);
        }, 5000);
    }, [counterQuestions, contents, documentVisibilityStatus]);
    useEffect(function () {
        if (token && eventId && moderatorPusherSingleton === null && (isModerator || isChairman)) {
            if (!(window === null || window === void 0 ? void 0 : window.Cypress)) {
                var pusher = init(token);
                setModeratorPusherSingleton(pusher);
                pusher.connection.bind("connected", handleConnection);
                pusher.connection.bind("unavailable", function () { return handleDisconnection("unavailable"); });
                pusher.connection.bind("disconnected", function () { return handleDisconnection("disconnected"); });
                pusher.connection.bind("failed", function () { return handleDisconnection("failed"); });
            }
            else
                setModeratorPusherSingleton(new PusherMock());
        }
        else if (moderatorPusherSingleton && !token && qaQuestionChannel === null) {
            try {
                moderatorPusherSingleton.disconnect();
            }
            catch (_a) { }
            setModeratorPusherSingleton(null);
        }
    }, [token, eventId, moderatorPusherSingleton, isChairman, isModerator, qaQuestionChannel]);
    useEffect(function () {
        if (eventId &&
            token &&
            selectedEpisodeId &&
            questionChannelEpId !== selectedEpisodeId &&
            moderatorPusherSingleton &&
            (isModerator || isChairman) &&
            qaQuestionChannel === null) {
            var episodeID = String(selectedEpisodeId);
            setQaQuestionChannel(subscribeToQAQuestionChannel({
                pusherSingleton: moderatorPusherSingleton,
                appId: eventId,
                episodeId: episodeID,
                isModerator: isModerator,
                isChairman: isChairman
            }, function (question) {
                dispatch(addQuestion(question));
                setCounterQuestions(function (prev) { return prev + 1; });
            }, function (question) {
                dispatch(sendFromItemsToSubmitted(question));
            }, function (question) {
                dispatch(deleteQuestionManually(question.id));
            }));
            setQuestionChannelEpId(selectedEpisodeId);
        }
        else if (eventId &&
            token &&
            selectedEpisodeId &&
            questionChannelEpId !== selectedEpisodeId &&
            moderatorPusherSingleton &&
            (isModerator || isChairman) &&
            qaQuestionChannel !== null) {
            try {
                qaQuestionChannel.unbind_all();
                qaQuestionChannel.unsubscribe();
            }
            catch (_a) { }
            setQaQuestionChannel(null);
        }
        else if (!token && qaQuestionChannel) {
            try {
                qaQuestionChannel.unsubscribe();
            }
            catch (_b) { }
            setQaQuestionChannel(null);
            setQuestionChannelEpId(null);
        }
    }, [
        eventId,
        token,
        selectedEpisodeId,
        isChairman,
        isModerator,
        moderatorPusherSingleton,
        qaQuestionChannel,
        questionChannelEpId,
        connectedCounter
    ]);
};
